module.exports = __webpack_public_path__ + "f8b06a3ad3776163035884280873825e.svg";